import * as React from 'react';

interface IParagraphProps extends React.PropsWithChildren {
	fillParent?: 'full' | 'mid' | 'narrow'; // how much of the parent container should paragraphs use? defaults to full
	fontSize?: 'c1' | 'd1' | 'e1' | 'c2'; // defaults to d1
	additionalClasses?: string[];
}

export const Paragraph: React.FC<IParagraphProps> = ({ fillParent, fontSize, additionalClasses, children }) => {
	const classes = [
		`paragraph--${fontSize || 'd1'}`,
		`paragraph--${fillParent || 'full'}`,
		...additionalClasses || []
	];

	return <p className={classes.join(' ')}>{children}</p>;
};
